module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"back":"Gehen Sie zur Homepage","denied":"Zugriff abgelehnt"},"en":{"back":"Go to homepage","denied":"Access denied"},"it":{"back":"","denied":""},"lt":{"back":"Eiti į pagrindinį puslapį","denied":"Prieiga atmesta"},"pl":{"back":"Przejdź do strony głównej","denied":"Odmowa dostępu"}}')
  delete Component.options._Ctor
}
